import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

type StyledTextFieldProps = TextFieldProps & {
  shouldHighlight?: boolean;
};

const StyledTextField: React.FC<StyledTextFieldProps> = ({ shouldHighlight = false, ...props }) => {
  return (
    <TextField
      variant='standard'
      {...props}
      InputProps={{
        ...props.InputProps,
        sx: {
          '&:before': {
            borderBottomColor: shouldHighlight ? 'orange' : 'rgba(0, 0, 0, 0.42)', // default underline color
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottomColor: shouldHighlight ? 'orange' : 'rgba(0, 0, 0, 0.87)', // hover underline color
          },
          '&:after': {
            borderBottomColor: shouldHighlight ? 'orange' : undefined, // focused underline color
          },
          ...props.InputProps?.sx,
        },
      }}
    />
  );
};

export default StyledTextField;
